export default {
    data() {
        const cache = localStorage.getItem('__active_table_fields');

        return {
            activeTableColumnsCache: cache === null ? {} : JSON.parse(cache),
            activeFields: []
        };
    },
    methods: {
        activateColumn(field) {
            this.activeFields.push(field);
            this.sortActiveColumns();
            this.activateTableColumn(field);
        },

        inactivateColumn(index, field) {
            this.activeFields.splice(index, 1);
            this.inactivateTableColumn(field);
        },

        initializeTableColumns(columns) {
            this.activeFields = columns.filter(f => {
                if (f.active && !this.isTableColumnDefined(f)) {
                    return true;
                }

                return this.isTableColumnActive(f);
            });
            this.sortActiveColumns();
        },

        sortActiveColumns() {
            this.activeFields.sort((a, b) => a.order - b.order);
        },

        activateTableColumn(columnDefinition, namespace) {
            const uniqueKey = this.___activeTableUniqueKey(namespace);

            if (!this.activeTableColumnsCache[uniqueKey]) {
                this.activeTableColumnsCache[uniqueKey] = {};
            }

            this.activeTableColumnsCache[uniqueKey][columnDefinition.key] = true;
            this.saveActiveTableColumns();
        },

        inactivateTableColumn(columnDefinition, namespace) {
            const uniqueKey = this.___activeTableUniqueKey(namespace);

            if (!this.activeTableColumnsCache[uniqueKey]) {
                this.activeTableColumnsCache[uniqueKey] = {};
            }

            this.activeTableColumnsCache[uniqueKey][columnDefinition.key] = false;
            this.saveActiveTableColumns();
        },

        isTableColumnDefined(columnDefinition, namespace) {
            const uniqueKey = this.___activeTableUniqueKey(namespace);
            return this.activeTableColumnsCache[uniqueKey] && this.activeTableColumnsCache[uniqueKey].hasOwnProperty(columnDefinition.key);
        },

        isTableColumnActive(columnDefinition, namespace) {
            const uniqueKey = this.___activeTableUniqueKey(namespace);

            return this.isTableColumnDefined(columnDefinition, namespace)
                && this.activeTableColumnsCache[uniqueKey][columnDefinition.key];
        },

        saveActiveTableColumns() {
            localStorage.setItem('__active_table_fields', JSON.stringify(this.activeTableColumnsCache));
        },

        ___activeTableUniqueKey(namespace) {
            return this.$router.currentRoute.name + '_' + namespace;
        }
    },
};
